import { Grid, Typography } from "@mui/material";
import * as React from "react";

const UserHeaderComponent: React.FunctionComponent<any> = ({
  icon,
  title,
  value,
  xs = 4,
}) => {
  return (
    <Grid container item xs={xs} alignItems="center">
      <img src={icon} alt="coins" width="30" />
      &nbsp;&nbsp;
      <Typography
        sx={{
          fontSize: "17px",
        }}
      >
        {title}
      </Typography>
      &nbsp;&nbsp;
      <Typography
        color="primary"
        fontWeight="bolder"
        sx={{
          fontSize: "20px",
        }}
      >
        {value}
      </Typography>
    </Grid>
  );
};

export default UserHeaderComponent;
